<app-widget [widget-meta]="this.data" class="widget-my-courses"
  itemCount="{{ enrollmentService.enrollmentCount }}"
  externalLink="{{lmsLink}}"
  externalLinkText="Canvas"
  showHelp="true">
  @if (enrollments$ | async; as data) {
    <div>
      <div class="row">
        <div class="col-md-12 d-grid">
          <a class="btn btn-xs up carousel-control" href="#carousel-example-vertical" role="button" data-bs-slide="prev">
            <i class="fas fa-chevron-up"></i>
            Previous
            <i class="fas fa-chevron-up"></i>
          </a>
        </div>
      </div>
      <div class="row justify-content-center">
        <div id="carousel-example-vertical" data-bs-interval="false" data-bs-ride="false" class="vertical carousel slide col-md-12">
          <div class="carousel-inner">
            @for (page of data.pages; track page) {
              <div class="carousel-item" [ngClass]="{ active: page == data.defaultPage }">
                <div class="container">
                  <div class="row">
                    <div class="col-md-1">{{i}}</div>
                    <div class="col-md-10">
                      <div class="row term-container">
                        <div class="col-1"></div>
                        <div class="col-md-10 col-sm-10 term-container__description ">
                          <strong>{{ this.getTitle(page, data.currentYear) }}</strong><br />
                          @if (!!data.lookupCreditHours) {
                            <span>{{data.lookupCreditHours[page]}} Enrolled Credit Hours</span>
                            }<br />
                            <span class="me-4">
                              Sort by:
                              <a class="link-dark pointer" [ngClass]="{'bold-text':enrollmentService.sortSectionsByTitle}" (click)="changeSectionSorting(true)">Title</a> |
                              <a class="link-dark pointer" [ngClass]="{'bold-text':!enrollmentService.sortSectionsByTitle}" (click)="changeSectionSorting(false)">Start Date</a>
                            </span>
                            <span>
                              Waitlisted:
                              <a class="link-dark pointer" [class.bold-text]="showWaitlisted" (click)="updateWaitlistDisplay()">Show</a> |
                              <a class="link-dark pointer" [class.bold-text]="!showWaitlisted" (click)="updateWaitlistDisplay()">Hide</a>
                            </span>
                          </div>
                          <div class="col-1"></div>
                          <!--<div class="col-4">
                          <div class="my-courses-course__progress">
                            <div *ngIf="term.PercentComplete != 100">
                              <easy-pie-chart [ngbTooltip]="[term.PercentComplete + '% Complete']" [percent]="term.PercentComplete" [options]="options"></easy-pie-chart>
                            </div>
                            <div class="term-complete text-center" *ngIf="term.PercentComplete == 100">
                              <i class="fas fa-check-circle"></i>
                            </div>
                          </div>
                        </div>-->
                      </div>
                    </div>
                  </div>
                </div>
                @for (enrollment of data.enrollments; track enrollment) {
                  @if (showWaitlisted || (!showWaitlisted && (enrollment.Status != 'Waitlisted'))) {
                    @if (enrollment.PageNumber == page) {
                      <div class="my-courses-course">
                        <!-- Later when show the section's title, we might want to iterate enrollment.Section.Terms in
                        order to show the terms associated with that section. -->
                        <div class="row">
                          <div class="col-md-1 col-lg-1 col-sm-1">
                            @if (enrollment.Status == 'Waitlisted') {
                              <div class="fa-stack" placement="right" [ngbTooltip]="['Waitlisted']">
                                <i class="my-courses-course__warning far fa-circle fa-stack-2x"></i>
                                @if (!enrollment.Section.AllowsAbandon) {
                                  <strong class="fa-stack-1x">W</strong>
                                }
                                @if (enrollment.Section.AllowsAbandon) {
                                  @if (enrollment.Rank == 0) {
                                    <strong class="fa-stack-1x">W</strong>
                                  }
                                  @if (enrollment.Rank > 0) {
                                    <strong class="fa-stack-1x">{{enrollment.Rank}}</strong>
                                  }
                                }
                              </div>
                            }
                            @if (enrollment.Status == 'Audited') {
                              <div class="fa-stack" placement="right" [ngbTooltip]="Auditing">
                                <i class="my-courses-course__warning far fa-circle fa-stack-2x"></i>
                                <strong class="fa-stack-1x">A</strong>
                              </div>
                            }
                            @if (enrollment.Status == 'Waitlisted' && enrollment.Conflicts.length > 0 && auth.hasFeature('WaitlistManagement')) {
                              <div class="fa-stack" placement="right" [ngbTooltip]="['Conflicts']">
                                <a [routerLink]="['/catalog']" [queryParams]="{tab: 'waitlistManagement'}">
                                  <i class="my-courses-course__warning far fa-circle fa-stack-2x"></i>
                                  <strong class="fa-stack-1x">C</strong>
                                </a>
                              </div>
                            }
                            @if (isDroppable( enrollment.Section.Id, data.enrollments) && auth.hasFeature('WaitlistManagement')) {
                              <div class="fa-stack" placement="right" [ngbTooltip]="['AutoDrop']">
                                <a [routerLink]="['/catalog']" [queryParams]="{tab: 'waitlistManagement'}">
                                  <i class="my-courses-course__warning far fa-circle fa-stack-2x"></i>
                                  <strong class="fa-stack-1x"><i class="fas fa-arrow-down"></i></strong>
                                </a>
                              </div>
                            }
                          </div>
                          <div class="col-md-4 col-lg-5 col-sm-4 my-courses-title">
                            <span class="course">
                              @if (!!enrollment.Section.LmsUrl) {
                                <a target="_blank" href="{{enrollment.Section.LmsUrl}}">{{ enrollment.Section.Title }}</a>
                              }
                              @if (!enrollment.Section.LmsUrl) {
                                <span>{{ enrollment.Section.Title }}</span>
                              }
                            </span><br />
                            {{ enrollment.Section.CourseCode}}-{{enrollment.Section.SectionNumber }}:
                            @for (termId of enrollment.Section.Terms; track termId; let isLast = $last) {
                              <span>
                                {{this.getTermName(data.terms, termId)}}@if (!isLast) {
                                <span>,</span>
                              }
                            </span>
                          }
                          <br />
                          <span>Credit Hours: {{enrollment?.CreditHours}} - {{enrollment.Section.Type}} </span>
                          @if (enrollment.Section.CoursePackReq != '') {
                            <br />
                                                Course Pack: <a [href]="'https://coursepacks.xanedu.com/thirdparty?REQ=' + enrollment.Section.CoursePackReq + '&STUDENTID=' + auth.token.payload.Pid" target="_blank"><i class="fas fa-laptop"></i> Web </a>
                                                @if (enrollment.Section.CoursePackMobile != '') {
                              <a [href]="enrollment.Section.CoursePackMobile" target="_blank" class="ps-1"> <i class="fas fa-mobile-alt"></i> App</a>
                            }
                          }
                          @for (instructor of enrollment.Section.Instructors; track instructor) {
                            <div>
                              <a class="instructor" href="javascript:void(0)" (click)="openProfile(data.instructors[instructor])">
                                {{ data.instructors[instructor]?.Name }}
                              </a>
                            </div>
                          }
                        </div>
                        <div class="col-md-4 col-lg-3 col-sm-4 my-courses-meeting">
                          @for (meeting of enrollment.Section.Meetings; track meeting) {
                            <span>
                              {{ meeting.Days }} {{ meeting.Start }} - {{ meeting.End }}<br />
                              {{ meeting.Building }} {{ meeting.Room }}
                            </span>
                          }
                          <span class="fw-bold">
                            {{enrollment.Section.SeatLabel}}
                          </span>
                          @if (!!enrollment.Section.NonStandardMeetingInfo) {
                            <span>
                              <br />{{enrollment.Section.NonStandardMeetingInfo}}
                            </span>
                          }
                          <span>
                            <br />{{enrollment.Section.StartDate | date:'shortDate'}} - {{enrollment.Section.EndDate | date:'shortDate'}}
                          </span>
                        </div>
                        <div class="col-md-3 col-lg-2 col-sm-3 my-courses-classmates">
                          @if (!!enrollment.Section.ShowClassmates) {
                          <button [routerLink]="['/people']"
                                  [queryParams]="{sectionid: enrollment.Section.Id, tab: 'classmates'}"
                                  class="btn btn-sm btn-primary me-1 mt-1">
                            Classmates
                          </button>
                          }

                          @if (enrollment.ShowRecordingButton && profile.profile$ | async; as profile) {
                          <button class="btn btn-sm btn-primary me-1 mt-1" [ngbTooltip]="['Request a class recording']"
                                  (click)="openRecordingRequest(enrollment.Section, profile.biodata.id)">
                            Record
                            <span class="sr-only">Request a class recording</span>

                          </button>
                          }

                          @if (enrollment.Section.TodosForClass.length > 0) {
                          <div>
                            <button class="badge badge-pill bg-warning text-dark me-1" (click)="open(todos, enrollment.Section.TodosForClass )">  {{enrollment.Section.TodosForClass.length}} ToDos</button><br />
                          </div>
                          }
                          <!--  Drop button -->
                          @if (registration && enrollment.Status != 'Waitlisted') {
                          @if (hasActiveRound(rounds, enrollment.Section.RoundId) && enrollment.Section.AllowsDrop) {
                          <button class="btn-danger btn-sm btn mt-1"
                                  (click)="drop(enrollment.Section,'Drop')" [disabled]="enrollmentService.isDropRunning[enrollment.Section.Id]">
                            Drop {{enrollment.Section.SeatLabel}}
                            @if (enrollmentService.isDropRunning[enrollment.Section.Id]) {
                            <span class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
                            }
                            <span class="sr-only">Drop</span>
                          </button>
                          }
                          }
                          <!--  Manage Conflicts/Abandon button.  If the user has conflicts and can participate in Waitlist Management they will see Manage Conflicts -->
                          @if (enrollment.Status == 'Waitlisted' && !enrollment.Section.HasClassEnded && enrollment.Section.AllowsAbandon) {
                          <button class="btn btn-sm col-12 mt-1" [disabled]="enrollmentService.isDropRunning[enrollment.Section.Id]"
                                  [ngClass]="((enrollment.Conflicts.length > 0) && auth.hasFeature('WaitlistManagement')) ? 'btn-primary' : 'btn-danger'"
                                  (click)="((enrollment.Conflicts.length > 0) && auth.hasFeature('WaitlistManagement')) ? manage(enrollment, data) : drop(enrollment.Section,'Abandon')">
                            {{((enrollment.Conflicts.length > 0) && auth.hasFeature('WaitlistManagement')) ? 'Manage Conflict' : 'Abandon ' + enrollment.Section.SeatLabel}}
                            @if (enrollmentService.isDropRunning[enrollment.Section.Id]) {
                            <span class="loader loader-sm loader-light ms-1" role="status" aria-hidden="true"></span>
                            }
                          </button>
                          }
                        </div>
                      </div>
                    </div>
                  }
                }
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div class="d-grid">
      <a class="btn btn-xs down carousel-control" href="#carousel-example-vertical" role="button" data-bs-slide="next">
        <i class="fas fa-chevron-down"></i>
        Next
        <i class="fas fa-chevron-down"></i>
      </a>
    </div>
  </div>
} @else {
  <div class="widget-loading text-center">
    <i class="fas fa-circle-notch fa-spin"></i>
  </div>
}
<ng-template #todos let-modal>
  <div class="{{profile.theme}}">
    <div class="modal-header">
      <h4 tabindex="0" ngbAutofocus class="modal-title" id="modal-basic-title">Canvas To Do's</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      </button>
    </div>
    <div class="modal-body p-0 ps-3">
      @for (todo of todoList; track todo) {
        <div class="my-courses-todos">
          <div class="col-md-12 col-lg-12 col-sm-12">
            <span class="assignment">
              <a target="_blank" href="{{todo.assignmentUrl}}">{{ todo.name }}</a>
            </span><br />
            Due: {{ todo.dueAt }}
            <br />
            <span>Points: {{ todo.points }}</span>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
</app-widget>
